var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-draggable-resizable', {
    staticClass: "tag",
    attrs: {
      "w": _vm.size.width,
      "h": _vm.size.height,
      "x": _vm.axis.x,
      "y": _vm.axis.y,
      "z-index": 9,
      "draggable": false,
      "resizable": false
    }
  }, [_vm.value.type === 'text-employer' ? _c('div', {
    staticClass: "field-input-wrap"
  }, [_c('v-text-field', {
    staticClass: "v-input--small",
    attrs: {
      "readonly": "",
      "flat": "",
      "solo": "",
      "hide-details": ""
    },
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1) : _vm._e(), _vm.value.type === 'text-employee' ? _c('div', {
    staticClass: "field-input-wrap"
  }, [_c('v-text-field', {
    staticClass: "v-input--small",
    attrs: {
      "readonly": "",
      "flat": "",
      "solo": "",
      "hide-details": ""
    },
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1) : _vm._e(), _vm.value.type === 'check' ? _c('div', {
    staticClass: "field-input-wrap"
  }, [_c('div', {
    staticClass: "checkbox-wrap"
  }, [_c('v-checkbox', {
    attrs: {
      "readonly": "",
      "ripple": false,
      "hide-details": ""
    },
    model: {
      value: _vm.content,
      callback: function callback($$v) {
        _vm.content = $$v;
      },
      expression: "content"
    }
  })], 1)]) : _vm._e(), _vm.value.type === 'canvas' ? _c('div', {
    staticClass: "field-input-wrap"
  }, [_c('v-img', {
    attrs: {
      "src": _vm.value.content,
      "readonly": "",
      "hide-details": ""
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }